module.exports = __webpack_public_path__ + "static/img/association.65d9970.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/association.png
// module id = wZCi
// module chunks = 1